import { useIntl } from "react-intl";
import { useState } from "react";
import type { TField } from "@shared/types/form";
import { Button } from "@shared/ui/button";
import { Eye, EyeOff } from "lucide-react";
import { TextField } from "./text-field";

export function PasswordField({ label, ...props }: TField) {
	const intl = useIntl();
	const [visible, setVisible] = useState(false);

	return (
		<TextField
			label={label}
			type={visible ? "text" : "password"}
			placeholder={intl.formatMessage({
				id: "form.field.password.placeholder",
				defaultMessage: "******",
			})}
			className="pr-10"
			trailingIcon={
				<Button
					className="absolute top-0 right-0 h-full px-3 hover:bg-transparent cursor-pointer"
					onClick={() => setVisible(!visible)}
					size="icon"
					type="button"
					variant="ghost"
				>
					{visible ? (
						<EyeOff className="size-4 text-muted-foreground" />
					) : (
						<Eye className="size-4 text-muted-foreground" />
					)}
				</Button>
			}
			{...props}
		/>
	);
}
